import axios from "../config/axios";

export async function updateList(keyLista, creado_por, option) {
  return await axios.put(
    "/gestion_notificaciones/notificaciones/api/v1/update_list",
    {
      keyLista,
      creado_por,
      option
    }
  );
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudListas.js